import type {
  ISite,
  ISiteSystem,
  ISiteSystemEquipment,
  ISiteSystemsState,
  ISiteSystemType,
} from '@/Core.Service.Domain/Sites/SiteSystems/types/index.ts';

const SET_SITE_SYSTEMS = (
  state: ISiteSystemsState,
  payload: ISiteSystem[]
): void => {
  state.siteSystems = payload;
};

const SET_SITE_SYSTEM = (
  state: ISiteSystemsState,
  payload: ISiteSystem | null
): void => {
  state.siteSystem = payload;
};

const SET_SITE_SYSTEM_TYPES = (
  state: ISiteSystemsState,
  payload: ISiteSystemType[]
): void => {
  state.siteSystemTypes = payload;
};

const SET_SITES_FOR_SELECTOR = (
  state: ISiteSystemsState,
  payload: ISite[]
): void => {
  state.sitesForSelector = payload;
};

const SET_EQUIPMENT_FOR_SITE = (
  state: ISiteSystemsState,
  payload: ISiteSystemEquipment[]
): void => {
  state.equipmentForSite = payload;
};

const SET_SITE_SYSTEMS_LOADING = (
  state: ISiteSystemsState,
  payload: boolean
): void => {
  state.isSiteSystemsLoading = payload;
};

const SET_SITE_SYSTEM_SEARCH_TERM = (
  state: ISiteSystemsState,
  payload: string
): void => {
  state.siteSystemSearchTerm = payload;
};

export default {
  SET_SITE_SYSTEMS,
  SET_SITE_SYSTEM,
  SET_SITE_SYSTEM_TYPES,
  SET_SITES_FOR_SELECTOR,
  SET_EQUIPMENT_FOR_SITE,
  SET_SITE_SYSTEMS_LOADING,
  SET_SITE_SYSTEM_SEARCH_TERM,
};
